var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-field',{attrs:{"label":_vm.label,"type":'is-'+_vm.color}},[_c('b-switch',{attrs:{"size":'is-'+_vm.size,"disabled":!_vm.enabled},on:{"input":_vm.onChangeValue},model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }